// Phase 24B — Working report (per-user per-day summary)
import TransactionReportPage from "./TransactionReportPage";

export default function WorkingReport() {
  return (
    <TransactionReportPage
      slug="working"
      testidPrefix="working-report"
      title="Working Report"
      subtitle="One row per user per day — attendance, first/last call, TC/PC/NC, totals."
      initialDaysBack={30}
      filterConfig={{ showUser: true }}
    />
  );
}
